module.exports = __webpack_public_path__ + "img/3.09fd34ca.png";